import { useQuery } from "@tanstack/react-query";
import { Address } from "viem";

import { useAccount } from "#/store/wallet/account/account";

import { fetchReferralsByAccount } from "../referrals.service";

export const useReferralsByAccount = () => {
  const { account } = useAccount();

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["fetchReferralsByAccount", account],
    queryFn: () => fetchReferralsByAccount(account as Address),
    enabled: Boolean(account),
    select: (referrals) => ({
      referrals,
      redeemers: referrals
        .flatMap((r) => r.redeemers ?? [])
        .concat({
          usedBy: account as Address,
          usedAt: new Date(0),
        }),
    }),
  });

  return {
    referrals: data?.referrals ?? [],
    redeemers: data?.redeemers ?? [],
    isLoading: isFetching || isLoading,
    refetch,
  };
};
